// tab ids
const PEER_TAB_ID = 'pendingpeer';
const APPROVAL_TAB_ID = 'pendingapproval';
const CIRCUITCHECK_TAB_ID = 'circuitchecks';

const INITIAL_COMMS_SENT = 'initialcomms';
const APPROVED = 'fullyapproved';
const CLOUSER = 'pendingclosure';

const DEFAULT_TAB = PEER_TAB_ID;

export {
  PEER_TAB_ID,
  CIRCUITCHECK_TAB_ID,
  APPROVAL_TAB_ID,
  DEFAULT_TAB,
  INITIAL_COMMS_SENT,
  APPROVED,
  CLOUSER,
};
